import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';

export default class HealthcareServiceModifier extends BackboneElement {
    static __className = 'HealthcareServiceModifier';

    __objectStructure = {
        code: String,
        position: Number,
        includeByDefault: Boolean,
    };

    constructor(constructJson, className = 'HealthcareServiceModifier') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
